/**
 * 頁面加載狀態列舉
 * @enum {PageLoadingStoreEnum}
 */
export enum PageLoadingStoreEnum {
    /**
     * Key
     */
    Key = 'pageLoadingState',
}
